/**
 * @copyright Copyright MIDAS Eduction, LLC. (https://www.midaseducation.com/)
 */

import {defineMessages} from 'react-intl';
import RouteLinkItem from 'components/navigation/side-navigation/item/RouteLinkItem';

const messages = defineMessages({
  title: {id: 'navigation.microcredentialing.approvals'},
});

const ApprovalsItem = () => (
  <RouteLinkItem
    route="midas/microcredentialing/approvals"
    title={messages.title}
  />
);

export default ApprovalsItem;
